import React, { useRef, useState } from 'react';
import AgreementResult from '../../../models/AgreementResult';
import styles from './sign_agreement.module.scss';

type Props = {
  agreement?: AgreementResult;
  useScrollIndicator?: boolean;
  onError?: (error?: any) => void;
}

/**
 * Agreement preview rendered as an img.
 */
export const ImgAgreement: React.FC<Props> = ({ agreement, useScrollIndicator, onError }) => {
  const [scrollIndicatorVisible, setScrollIndicatorVisible] = useState(true);

  const imgRef = useRef<HTMLImageElement>(null);
  const imgContainerRef = useRef<HTMLDivElement>(null);

  const scrollTarget = 1200;

  return (
    <div
      ref={e => imgContainerRef.current = e}
      className={styles.agreementImgContainer}
      onScroll={e => {
        if (scrollIndicatorVisible && e.currentTarget.scrollTop >= scrollTarget - 1) {
          setScrollIndicatorVisible(false);
        }
      }}>
      <img
        ref={e => imgRef.current = e}
        src={agreement.uri.replace('.pdf', '.jpg')}
        onError={onError} 
        alt="Agreement"
        loading='eager'
        decoding='async'
        />
      {
        /*
        useScrollIndicator ? (
          <Button
            weight="simple"
            className={cls([styles.scrollIndicator, scrollIndicatorVisible ? styles.visible : null])}
            onClick={() => imgContainerRef.current?.scrollTo({ left: 0, top: scrollTarget, behavior: 'smooth' })}>
            <FontAwesomeIcon name="chevron-down" className={styles.icon} />
          </Button>
        ) : null
        */
      }
    </div>
  )
}